import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    baseRegionInfo: null,
    ratingCards: [],
    ratingList: [],
    indicatorCards: [],
    dynamicCards: [],
    eventsCountByTypes: [],
    agreementsCountByTypes: [],
    representativeAbroadInfo: null,
    representativeAbroadInfoTable: {
      firstItemNumber: 1,
      itemCount: 1,
      items: [],
      itemsTotal: 1,
      pageNumber: 1,
      pageSize: 10,
      pagesTotal: 1,
    },
  },
};
